import React from "react";
import { Link } from "react-router-dom";
import { Row, Col, Container } from "reactstrap";

const Footer = () => {
    return (
        <React.Fragment>
            <footer className="footer">
                <Container fluid>
                    <Row>
                        <Col sm={6} style={{fontSize:"11px"}}>
                            {new Date().getFullYear()} © JA EVAL
                        </Col>
                        <Col sm={6} style={{fontSize:"11px"}}>
                            <div className="text-sm-end d-none d-sm-block">
                            Développé par <a href="https://ideracloud.com" target="_blank">IDERACLOUD</a> en partenariat avec <a href="#" target="_blank">YALILA GROUP</a>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    );
};

export default Footer;
